import { Extension, type Editor } from "@tiptap/core";
import { syncPlaybookPendingFromDoc } from "./collaboratePlaybookChips";
import { syncSignoffPendingFromDoc } from "./collaborateSignoffChips";

export type CollaborateEditorStorage = {
  /** After /sign-off, next @ opens sign-off user picker (one person). */
  signoffPending: boolean;
  /** After /update-playbook, next @ opens playbook assignee picker (one person). */
  playbookPending: boolean;
};

export const CollaborateEditorExtension = Extension.create({
  name: "collaborate",

  addStorage() {
    return {
      signoffPending: false,
      playbookPending: false,
    } satisfies CollaborateEditorStorage;
  },

  onUpdate({ editor }) {
    syncSignoffPendingFromDoc(editor);
    syncPlaybookPendingFromDoc(editor);
  },
});

export function getCollaborateEditorStorage(editor: Editor): CollaborateEditorStorage {
  return editor.storage.collaborate;
}

export function setSignoffPending(editor: Editor, pending: boolean): void {
  editor.storage.collaborate.signoffPending = pending;
}

export function setPlaybookPending(editor: Editor, pending: boolean): void {
  editor.storage.collaborate.playbookPending = pending;
}

declare module "@tiptap/core" {
  interface Storage {
    collaborate: CollaborateEditorStorage;
  }
}
